<template>
    <div class="col-md-12">
        <!-- Datos generales del contratante -->
        <div class="col-md-3">
            <label class="control-label"><vue-feather type="user" size="16"></vue-feather> Generales</label>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">* RFC</label>
                    <input class="form-control" type="text" placeholder=""
                        v-bind:class="mensajeRfcInvalido ? 'is-invalid' : ''" required="required"
                        v-model="store.rfc" :readonly="rfcBloqueado" @keyup.enter="getContratante">
                    <div class="invalid-feedback">{{ mensajeRfcInvalido }}</div>
                </div>
            </div>
            <div class="col-md-1">
                <div class="form-group">
                    <label class="control-label d-block invisible">Buscar</label>
                    <button type="button" class="btn btn-primary" :disabled="loading || rfcBloqueado" @click="getContratante">
                        <vue-feather type="search" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">CURP</label>
                    <input class="form-control" type="text" placeholder=""
                        v-bind:class="formSubmitted && !store.curp ? 'is-invalid' : ''" required="required"
                        v-model="store.curp" :disabled="store.disabledRFC">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Fecha de Nacimiento</label>
                    <input v-model="store.fechaNacimiento" :disabled="store.disabledRFC" class="form-control" type="date" required="required">
                </div>
            </div>
            <div class="col-md-1">
                <div class="form-group">
                    <label class="control-label">Edad</label>
                    <input v-model="store.edad" :disabled="store.disabledRFC" class="form-control" type="number" readonly>
                </div>
            </div>
        </div>
        <div class="row" v-if="resultadoBusqueda || errorBusqueda">
            <div class="col-md-12">
                <div v-if="rfcBloqueado && !store.polizaId" class="mb-2">
                    <button type="button" class="btn btn-link btn-sm p-0" @click="buscarOtroContratante">
                        Buscar otro contratante
                    </button>
                </div>
                <div v-if="errorBusqueda" class="alert alert-danger py-2" role="alert">{{ errorBusqueda }}</div>
                <div v-else-if="resultadoBusqueda === 'nuevo'" class="alert alert-info py-2" role="status">
                    Contratante nuevo: capture sus datos.
                </div>
                <div v-else class="alert alert-info py-2" role="status">
                    Contratante existente: sus datos se recuperaron y puede actualizarlos.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">* Nombre(s)</label>
                    <input v-model="store.nombre" :disabled="store.disabledRFC" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">* Apellido Paterno</label>
                    <input v-model="store.paterno" :disabled="store.disabledRFC" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">Apellido Materno</label>
                    <input v-model="store.materno" :disabled="store.disabledRFC" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
        </div>

        <hr />

        <!-- Sección de domicilios -->
        <div class="col-md-3">
            <label class="control-label"><vue-feather type="home" size="16"></vue-feather> Domicilios</label>
        </div>
        <!-- Domicilio Personal (fijo, siempre visible) -->
        <div>
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p><strong>Domicilio Personal</strong></p>
            </div>
            <FormDireccion v-model="domicilioPersonal" />
        </div>
        <!-- Checkbox: ¿domicilio fiscal igual al personal? -->
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="form-check">
                    <input type="checkbox" id="domicilioFiscalIgual" v-model="domicilioFiscalIgual" class="form-check-input">
                    <label for="domicilioFiscalIgual" class="form-check-label">¿El domicilio fiscal es el mismo que el personal?</label>
                </div>
            </div>
        </div>
        <!-- Domicilio Fiscal (solo si el checkbox está desmarcado) -->
        <div v-if="!domicilioFiscalIgual">
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p><strong>Domicilio Fiscal</strong></p>
            </div>
            <FormDireccion v-model="domicilioFiscal" />
        </div>

        <hr />

        <!-- Medios de contacto -->
        <div class="row mt-3">
            <div class="col-md-3">
                <label class="control-label"><vue-feather type="mail" size="16"></vue-feather> Medios de contacto</label>
            </div>
            <div class="col-md-9 text-end">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click="onAddMedioContacto">
                        <vue-feather type="plus" size="16"></vue-feather>
                    </button>
                </div>
            </div>
        </div>

        <!-- Datos de Medio de contacto -->
        <div v-for="(medio, index) in store.mediosContacto" :key="index">
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p class="mb-0">{{ getTipoMedioDescripcion(medio.tipoMedioId) || `Medio de contacto ${index + 1}` }}</p>
                <div v-if="index >= 3">
                    <button type="button" class="btn btn-light btn-sm me-2" @click="onToggleMinimizeMedioContacto(index)">
                        <vue-feather :type="medio.isMinimized ? 'plus' : 'minus'" size="16"></vue-feather>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" @click="onRemoveMedioContacto(index)">
                        <vue-feather type="trash-2" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div v-if="!medio.isMinimized" class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">* Tipo</label>
                        <select v-model="medio.tipoMedioId" class="form-control" :disabled="index < 3" required="required">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option v-for="tipo in store.tiposMediosContacto" :key="getTipoMedioId(tipo)" :value="getTipoMedioId(tipo)">{{ tipo.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">* Valor</label>
                        <input v-model="medio.descripcion" class="form-control" type="text" placeholder="" required="required">
                    </div>
                </div>
            </div>
        </div>

        <!-- Datos financieros -->
        <hr />
        <div class="row mt-3">
            <div class="col-md-3">
                <label class="control-label"><vue-feather type="dollar-sign" size="16"></vue-feather> Datos Financieros</label>
            </div>
            <div class="col-md-9 text-end">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click="onAddCuentaBancaria">
                        <vue-feather type="plus" size="16"></vue-feather>
                    </button>
                </div>
            </div>
        </div>
        <div v-for="(cuenta, index) in store.informacionFinanciera" :key="index">
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p>Cuenta Bancaria {{ index + 1 }}</p>
                <div>
                    <button type="button" class="btn btn-light btn-sm me-2" @click="onToggleMinimizeCuentaBancaria(index)">
                        <vue-feather :type="cuenta.isMinimized ? 'plus' : 'minus'" size="16"></vue-feather>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" @click="onRemoveCuentaBancaria(index)">
                        <vue-feather type="trash-2" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div v-if="!cuenta.isMinimized" class="row mt-3">
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">* Tipo de instrumento</label>
                        <select v-model="cuenta.instrumentoId" class="form-control" required="required">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option v-for="instrumento in store.instrumentos" :key="instrumento.id" :value="instrumento.id">{{ instrumento.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">* Institución bancaria</label>
                        <select v-model="cuenta.bancoId" class="form-control" required="required">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option v-for="banco in store.bancos" :key="banco.id" :value="banco.id">{{ banco.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">* Número de cuenta</label>
                        <input v-model="cuenta.cuenta" class="form-control" type="text" placeholder="" required="required">
                    </div>
                </div>
            </div>
        </div>
        <!-- Fin de datos financieros -->
        <hr class="mt-3" />
            <div class="mt-3 col-md-12">
                <p><b>* Campos obligatorios</b></p>
            </div>

            <div v-if="errores.length || error" class="mt-3 col-md-12">
                <div class="alert alert-danger py-2" role="alert">
                    <div v-if="error">{{ error }}</div>
                    <ul v-if="errores.length" class="mb-0">
                        <li v-for="mensaje in errores" :key="mensaje">{{ mensaje }}</li>
                    </ul>
                </div>
            </div>

            <div class="mt-3 col-md-12">
                <button class="btn btn-primary float-end" :disabled="loading" @click="guardaContratante">
                    {{ contratanteEncontrado ? 'Actualizar datos' : 'Guardar y continuar' }}
                </button>
            </div>

        </div>
</template>

<script>
import api from '@/axios';
import { useSeguroStore } from '@/stores/seguroStore';
import FormDireccion from '@/components/FormDireccion.vue';
import getField from '@/utils/getField';
import { normalizarRfc, mensajeRfc, validarContratante } from '@/utils/contratanteValidacion';

export default {
    components: { FormDireccion },
    emits: ['nextTab'],
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    computed: {
        // El RFC es la llave del contratante: una vez cargado o creado ya no se edita (FR-005).
        rfcBloqueado() {
            return !!this.store.contratanteId;
        },
        // Mensaje bajo el campo RFC: solo cuando ya se escribió algo o se intentó guardar.
        mensajeRfcInvalido() {
            if (!this.store.rfc && !this.formSubmitted) return null;
            return mensajeRfc(this.store.rfc);
        },
        domicilioFiscalIgual: {
            get() {
                return this.store.domicilioFiscalIgual;
            },
            set(val) {
                this.store.domicilioFiscalIgual = val;
            },
        },
        domicilioFiscal: {
            get() {
                if (!Array.isArray(this.store.domicilios)) return this.getEmptyDomicilioFiscal();
                const fiscal = this.store.domicilios.find(d => Number(d.tipoId) === 3);
                return fiscal || this.getEmptyDomicilioFiscal();
            },
            set(val) {
                this.upsertDomicilioFiscalInStore(val);
            },
        },
        domicilioPersonal: {
            get() {
                if (!Array.isArray(this.store.domicilios)) return {};
                const personal = this.store.domicilios.find(d => Number(d.tipoId) === 1);
                return personal || this.store.domicilios[0] || {};
            },
            set(val) {
                if (!Array.isArray(this.store.domicilios)) {
                    this.store.domicilios = [];
                }
                const personalIndex = this.store.domicilios.findIndex(d => Number(d.tipoId) === 1);
                const next = { ...val, tipoId: 1 };
                if (personalIndex >= 0) {
                    this.store.domicilios[personalIndex] = next;
                } else {
                    this.store.domicilios.unshift(next);
                }
            },
        },
    },
    data() {
        return {
            errores: [],
            error: null,
            errorBusqueda: null,
            loading: false,
            formSubmitted: false,
            // '' | 'nuevo' | 'existente': resultado de la última búsqueda por RFC
            resultadoBusqueda: '',
            contratanteEncontrado: false,
        };
    },
    async mounted() {
        await this.store.fetchTiposDomicilios();
        await this.store.fetchTiposMedios();
        await this.store.fetchBancos();
        await this.store.fetchInstrumentos();
        await this.initDomicilioPersonal();
        await this.initMediosContactoIniciales();
    },
    methods: {
        getTipoMedioId(tipo) {
            return tipo?.medioId ?? tipo?.id ?? tipo?.tipoMedioId ?? null;
        },
        getTipoMedioDescripcion(tipoId) {
            const tipos = Array.isArray(this.store.tiposMediosContacto) ? this.store.tiposMediosContacto : [];
            const found = tipos.find(tipo => String(this.getTipoMedioId(tipo)) === String(tipoId));
            return found?.nombre || '';
        },
        wizardDtoEtapa1() {
            return this.store.buildWizardDto(1);
        },
        async getContratante() {
            if (this.loading) return;
            this.error = null;
            this.errorBusqueda = null;
            const rfc = normalizarRfc(this.store.rfc);
            const mensaje = mensajeRfc(rfc);
            if (mensaje) {
                this.errorBusqueda = mensaje;
                return;
            }
            this.store.rfc = rfc;
            try {
                this.loading = true;
                const response = await api.get(`draft/contratante/rfc/${rfc}`);
                const data = response.data;
                if (!data?.id || !data.informacionPersonal) throw new Error('Respuesta inesperada');
                this.store.reiniciarContratante();
                this.poblarContratante(data);
                this.store.disabledRFC = 0;
                this.contratanteEncontrado = true;
                this.resultadoBusqueda = 'existente';
            } catch (err) {
                if (err?.response?.status === 404) {
                    // Un RFC que no existe es un contratante nuevo, no un error.
                    this.store.reiniciarContratante();
                    this.initDomicilioPersonal();
                    this.initMediosContactoIniciales();
                    // El reinicio borró la fecha de nacimiento que sugiere el RFC; se vuelve a derivar.
                    this.calcularEdadDesdeRFC(rfc);
                    this.store.disabledRFC = 0;
                    this.contratanteEncontrado = false;
                    this.resultadoBusqueda = 'nuevo';
                } else {
                    this.errorBusqueda = 'No se pudo consultar el contratante. Intente de nuevo.';
                }
            } finally {
                this.loading = false;
            }
        },
        // Vuelve al estado inicial para trabajar con otro RFC sin mezclar datos (FR-010).
        buscarOtroContratante() {
            this.store.reiniciarContratante();
            this.store.rfc = '';
            this.resultadoBusqueda = '';
            this.contratanteEncontrado = false;
            this.errores = [];
            this.error = null;
            this.errorBusqueda = null;
            this.formSubmitted = false;
            this.initDomicilioPersonal();
            this.initMediosContactoIniciales();
        },
        // Pasa la respuesta de draft/contratante/rfc/{rfc} (contrato en specs/007-wizard-etapa-contratante) al store.
        // Conserva domicilioId, medioId e informacionFinancieraId: el backend los usa para actualizar sin duplicar.
        poblarContratante(data) {
            const info = data.informacionPersonal;
            this.store.contratanteId = data.id;
            this.store.informacionPersonalId = info.id ?? null;
            this.store.curp = info.curp ?? '';
            this.store.fechaNacimiento = info.fechaNacimiento ? String(info.fechaNacimiento).split('T')[0] : '';
            this.store.edad = this.calcularEdad(this.store.fechaNacimiento);
            this.store.nombre = info.nombre ?? '';
            this.store.paterno = info.paterno ?? '';
            this.store.materno = info.materno ?? '';

            this.store.domicilios = (data.domicilios || []).map(d => ({
                domicilioId: d.domicilioId ?? null,
                tipoId: Number(d.tipoId ?? 0),
                codigoPostal: d.codigoPostal || '',
                codigoPostalId: d.codigoPostalId || null,
                estado: d.estado || '',
                estadoId: d.estadoId || null,
                municipio: d.municipio || '',
                municipioId: d.municipioId || null,
                colonia: d.colonia || '',
                calle: d.calle || '',
                ciudad: d.ciudad || '',
                paisId: d.paisId || 1,
                numeroExt: d.numeroExt ?? '',
                numeroInt: d.numeroInt ?? '',
                // Con código postal ya resuelto los campos del domicilio deben quedar editables.
                disabledCP: d.codigoPostal ? 0 : 1,
            }));
            this.domicilioFiscalIgual = !this.store.domicilios.some(d => Number(d.tipoId) === 3);
            this.initDomicilioPersonal();

            // Los tres medios base ocupan las primeras filas; cualquier otro medio (incluso de un tipo base repetido) va después.
            const tiposBaseMedios = [2, 4, 5];
            const mediosApi = (data.mediosContacto || []).map((m) => ({
                medioId: m.medioId ?? null,
                tipoMedioId: Number(m.tipoMedioId ?? 0),
                descripcion: m.descripcion ?? '',
                isMinimized: false,
            }));
            const usados = new Set();
            const base = tiposBaseMedios.map((tipo) => {
                const found = mediosApi.find((m) => m.tipoMedioId === tipo);
                if (found) {
                    usados.add(found);
                    return found;
                }
                return { medioId: null, tipoMedioId: tipo, descripcion: '', isMinimized: false };
            });
            this.store.mediosContacto = [...base, ...mediosApi.filter((m) => !usados.has(m))];

            this.store.informacionFinanciera = (data.informacionFinanciera || []).map((c) => ({
                informacionFinancieraId: c.informacionFinancieraId ?? null,
                instrumentoId: c.instrumentoId ?? '',
                bancoId: c.bancoId ?? '',
                cuenta: c.cuenta ?? '',
                isMinimized: false,
            }));
        },
        // Edad cumplida a hoy a partir de una fecha ISO (AAAA-MM-DD); vacía si no hay fecha válida.
        calcularEdad(fechaIso) {
            const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(fechaIso || '');
            if (!match) return '';
            const [yyyy, mm, dd] = match.slice(1).map(Number);
            const hoy = new Date();
            let edad = hoy.getFullYear() - yyyy;
            if (hoy.getMonth() + 1 < mm || (hoy.getMonth() + 1 === mm && hoy.getDate() < dd)) edad--;
            return edad;
        },
        calcularEdadDesdeRFC(rfc) {
            if (!rfc || rfc.length < 10) return;
            const rfcPattern = /^[A-ZÑ&]{3,4}(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])/i;
            const match = rfc.toUpperCase().match(rfcPattern);
            if (!match) return;
            const yy = parseInt(match[1], 10);
            const mm = parseInt(match[2], 10);
            const dd = parseInt(match[3], 10);
            const currentYear = new Date().getFullYear();
            const cutoff = currentYear % 100;
            const yyyy = yy <= cutoff ? 2000 + yy : 1900 + yy;
            const isoDate = `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
            this.store.fechaNacimiento = isoDate;
            this.store.edad = this.calcularEdad(isoDate);
        },
        async guardaContratante() {
            if (this.loading) return;
            this.formSubmitted = true;
            this.error = null;
            this.errores = validarContratante(this.store, {
                nombreTipoMedio: (tipo) => this.getTipoMedioDescripcion(tipo) || `tipo ${tipo}`,
            });
            if (this.errores.length) return;
            try {
                this.loading = true;
                const payload = this.wizardDtoEtapa1();

                let response;
                if (this.store.polizaId) {
                    response = await api.put(`wizard/poliza/${this.store.polizaId}`, payload);
                } else {
                    response = await api.post('wizard/poliza/', payload);
                }

                if (response.status >= 200 && response.status < 300) {
                    const data = response.data || {};
                    this.store.polizaId = data.polizaId ?? this.store.polizaId;
                    this.store.polizaVersionId = getField(data, 'polizaVersionId') ?? this.store.polizaVersionId;
                    this.store.contratanteId = data.contratanteId ?? this.store.contratanteId;
                    this.store.folio = data.folio ?? this.store.folio;
                    this.store.polizaNumero = data.numeroPoliza ?? this.store.polizaNumero;
                    this.store.informacionPersonalId = data.informacionPersonalId ?? this.store.informacionPersonalId;
                    this.store.etapaWizard = 1;
                } else {
                    this.error = 'No se pudo validar el envío de la información personal.';
                    return;
                }
            } catch (err) {
                const mensajeDelServidor = err?.response?.data?.message ?? err?.response?.data?.Message;
                this.error = typeof mensajeDelServidor === 'string' && mensajeDelServidor
                    ? mensajeDelServidor
                    : 'No se pudo guardar la información del contratante.';
                return;
            } finally {
                this.loading = false;
            }
            this.$emit('nextTab');
        },
        initDomicilioPersonal() {
            if (!Array.isArray(this.store.domicilios)) {
                this.store.domicilios = [];
            }
            const tienePersonal = this.store.domicilios.some(d => Number(d.tipoId) === 1);
            if (!tienePersonal) {
                this.store.domicilios.unshift({
                    tipoId: 1,
                    codigoPostal: '',
                    codigoPostalId: null,
                    estado: '',
                    estadoId: null,
                    municipio: '',
                    municipioId: null,
                    colonia: '',
                    calle: '',
                    ciudad: '',
                    paisId: 1,
                    numeroExt: '',
                    numeroInt: '',
                    disabledCP: 1,
                    isMinimized: false,
                });
            }
        },
        onAddMedioContacto() {
            if (!Array.isArray(this.store.mediosContacto)) {
                this.store.mediosContacto = [];
            }
            this.store.mediosContacto.push({
                tipoMedioId: '',
                descripcion: '',
                isMinimized: false,
            });
        },
        initMediosContactoIniciales() {
            if (!Array.isArray(this.store.mediosContacto)) {
                this.store.mediosContacto = [];
            }
            if (this.store.mediosContacto.length > 0) {
                return;
            }
            this.store.mediosContacto = [
                { tipoMedioId: 2, descripcion: '', isMinimized: false },
                { tipoMedioId: 4, descripcion: '', isMinimized: false },
                { tipoMedioId: 5, descripcion: '', isMinimized: false },
            ];
        },
        onRemoveMedioContacto(index) {
            if (index < 3) return;
            this.store.mediosContacto.splice(index, 1);
        },
        onToggleMinimizeMedioContacto(index) {
            if (index < 3) return;
            const medio = this.store.mediosContacto[index];
            medio.isMinimized = !medio.isMinimized;
        },
        onAddCuentaBancaria() {
            if (!Array.isArray(this.store.informacionFinanciera)) {
                this.store.informacionFinanciera = [];
            }
            this.store.informacionFinanciera.push({
                bancoId: '',
                instrumentoId: '',
                cuenta: '',
                isMinimized: false,
            });
        },
        onRemoveCuentaBancaria(index) {
            this.store.informacionFinanciera.splice(index, 1);
        },
        onToggleMinimizeCuentaBancaria(index) {
            const cuenta = this.store.informacionFinanciera[index];
            cuenta.isMinimized = !cuenta.isMinimized;
        },
        getEmptyDomicilioFiscal() {
            return {
                tipoId: 3,
                codigoPostal: '',
                codigoPostalId: null,
                estado: '',
                estadoId: null,
                municipio: '',
                municipioId: null,
                colonia: '',
                calle: '',
                ciudad: '',
                paisId: 1,
                numeroExt: '',
                numeroInt: '',
                disabledCP: 1,
            };
        },
        upsertDomicilioFiscalInStore(val) {
            if (!Array.isArray(this.store.domicilios)) {
                this.store.domicilios = [];
            }
            const fiscalIndex = this.store.domicilios.findIndex(d => Number(d.tipoId) === 3);
            const next = { ...val, tipoId: 3 };
            if (fiscalIndex >= 0) {
                this.store.domicilios[fiscalIndex] = next;
            } else {
                this.store.domicilios.push(next);
            }
        },
        removeDomicilioFiscalFromStore() {
            if (!Array.isArray(this.store.domicilios)) return;
            const fiscalIndex = this.store.domicilios.findIndex(d => Number(d.tipoId) === 3);
            if (fiscalIndex >= 0) {
                this.store.domicilios.splice(fiscalIndex, 1);
            }
        },
    },
    watch: {
        domicilioFiscalIgual(val) {
            if (val) {
                this.removeDomicilioFiscalFromStore();
            } else {
                const fiscalExistente = Array.isArray(this.store.domicilios)
                    ? this.store.domicilios.find(d => Number(d.tipoId) === 3)
                    : null;
                if (!fiscalExistente) {
                    this.upsertDomicilioFiscalInStore(this.getEmptyDomicilioFiscal());
                }
            }
        },
        // La edad siempre corresponde a la fecha de nacimiento; no se captura a mano.
        'store.fechaNacimiento'(val) {
            this.store.edad = this.calcularEdad(val);
        },
        'store.rfc'(val) {
            // Con un contratante cargado, la fecha de nacimiento es la guardada, no la que sugiere el RFC.
            if (this.store.contratanteId) return;
            this.calcularEdadDesdeRFC(val);
        },
    },
}
</script>
